export function getStyleProperty(element, property, options: any = {}) {
  const cs = getComputedStyle(element);
  let value: any = cs.getPropertyValue(property);
  if (value) {
    if (options.float) {
      value = parseFloat(value.replace("px", ""));
    }
    if (options.int) {
      value = parseInt(value.replace("px", ""));
    }
  }
  return value;
}

export function borderHeight(element) {
  return getStyleProperty(element, "border-top-width", { int: true }) + getStyleProperty(element, "border-bottom-width", { int: true });
}

export function paddingHeight(element) {
  return getStyleProperty(element, "padding-top", { int: true }) + getStyleProperty(element, "padding-bottom", { int: true });
}

export function contentHeight(element) {
  return element.clientHeight - borderHeight(element) - paddingHeight(element);
}
